import React from "react";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import BackButton from "../../shared/components/backButton";
import Layout from "../../shared/components/layout";

const ButtonContainer = styled.div`
  margin: 40px 0;
  font-family: gotham-500;
`;

const Label = styled.label`
  font-size: 16px;
`;

function SelectProvider({ providers }) {
  const { handleSubmit } = useForm();

  const onNext = () => {};

  return (
    <Layout
      banner={"Transfer Health Information"}
      header={"Select your previous provider"}
    >
      <BackButton></BackButton>

      <Label htmlFor="providers">
        Which insurance provider would you like to transfer data from?
      </Label>

      <form onSubmit={handleSubmit(onNext)}>
        <select
          className="form-control basic-input selector test"
          name="providers"
          defaultValue={"DEFAULT"}
        >
          <option value="DEFAULT" disabled>
            Select...
          </option>
          <option value="aetna">Aetna</option>
          <option value="anthem">Anthem</option>
          <option value="cigna">Cigna</option>
          <option value="humana">Humana</option>
        </select>

        <ButtonContainer>
          <button type="submit" className="btn btn-primary">
            Next
          </button>
        </ButtonContainer>
      </form>
    </Layout>
  );
}

export default SelectProvider;
